/**
 * Action types for NAT profile functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

export const GET_NAT_PROFILE = 'GET_NAT_PROFILE';
export const GET_NAT_PROFILE_SUCCESS = 'GET_NAT_PROFILE_SUCCESS';
export const GET_NAT_PROFILE_FAIL = 'GET_NAT_PROFILE_FAIL';
export const DELETE_NAT_PROFILE = 'DELETE_NAT_PROFILE';
export const DELETE_NAT_PROFILE_SUCCESS = 'DELETE_NAT_PROFILE_SUCCESS';
export const DELETE_NAT_PROFILE_FAIL = 'DELETE_NAT_PROFILE_FAIL';
export const ADD_NAT_PROFILE = 'ADD_NAT_PROFILE';
export const ADD_NAT_PROFILE_COMPLETE =  'ADD_NAT_PROFILE_COMPLETE';
export const EDIT_NAT_PROFILE = 'EDIT_NAT_PROFILE';
export const EDIT_NAT_PROFILE_COMPLETE =  'EDIT_NAT_PROFILE_COMPLETE';
export const NAT_ADD_TRIGGER = 'NAT_ADD_TRIGGER';